var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnsubscribe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m230.477 35.873 13.492 13.492L58.906 234.43l-13.493-13.493zm-57.085 185.221H154.31c0-15.945-3.93-30.988-10.874-44.211l14.015-14.014c10.124 17.07 15.94 36.98 15.94 58.225m57.243 0h-19.081c0-31.803-9.778-61.367-26.486-85.843l13.7-13.7c20.056 28.1 31.867 62.468 31.867 99.543M58.905 106.608c21.164 0 41.004 5.772 58.03 15.824l-14.025 14.023c-13.173-6.876-28.143-10.766-44.004-10.766zm0-57.243c36.995 0 71.295 11.76 99.36 31.736l-13.703 13.703c-24.44-16.63-53.934-26.358-85.656-26.358z"
})));
export default SvgUnsubscribe;